import styled from 'styled-components';

export const Container = styled.div`
  height: auto;
  width: 100%;
  background-color: #eee;
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const Content = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;

  h2 {
    margin: 0;
    font-size: var(--font-subtitle-size);
    margin-left: 1rem;
    font-weight: 500;
    margin-right: 2rem;
  }
`;

export const Closer = styled.div`
  cursor: pointer;
  height: auto;
  display: flex;
  align-items: center;
  padding-right: 1rem;
`;
